import { render, staticRenderFns } from "./MadeByComponent.vue?vue&type=template&id=04dc1366"
import script from "./MadeByComponent.vue?vue&type=script&lang=js"
export * from "./MadeByComponent.vue?vue&type=script&lang=js"
import style0 from "./MadeByComponent.vue?vue&type=style&index=0&id=04dc1366&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04dc1366')) {
      api.createRecord('04dc1366', component.options)
    } else {
      api.reload('04dc1366', component.options)
    }
    module.hot.accept("./MadeByComponent.vue?vue&type=template&id=04dc1366", function () {
      api.rerender('04dc1366', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/404-pages/MadeByComponent.vue"
export default component.exports